import { v7 as uuidv7 } from "uuid";

const isNonEmpty = (value) => value !== undefined && value !== null && String(value).trim() !== '';

export function generateAutomationStepId() {
    return uuidv7();
}

export function resolveAutomationStepId(step = {}) {
    if (step?.stepId) return String(step.stepId);
    if (step?.id) return String(step.id);
    return generateAutomationStepId();
}

export function resolveDynamicStepIdentity({ step = null, stepIndex = null, stepId = null, fallbackToIndex = true } = {}) {
    const resolvedStepId = isNonEmpty(stepId)
        ? String(stepId)
        : isNonEmpty(step?.stepId)
            ? String(step.stepId)
            : isNonEmpty(step?.id)
                ? String(step.id)
                : null;

    const numericStepIndex = Number.isFinite(Number(stepIndex))
        ? Number(stepIndex)
        : Number.isFinite(Number(step?.stepIndex))
            ? Number(step.stepIndex)
            : null;

    const candidateKeys = [];
    if (isNonEmpty(resolvedStepId)) candidateKeys.push(String(resolvedStepId));
    if (fallbackToIndex && Number.isFinite(numericStepIndex)) candidateKeys.push(String(numericStepIndex));

    const uniqueCandidateKeys = [...new Set(candidateKeys)];

    return {
        stepId: resolvedStepId,
        stepIndex: numericStepIndex,
        candidateKeys: uniqueCandidateKeys,
    };
}

export function getDynamicBindingsForStep(dynamicBindings, identity) {
    if (!dynamicBindings || typeof dynamicBindings !== 'object') return [];
    const keys = Array.isArray(identity?.candidateKeys) ? identity.candidateKeys : [];
    for (const key of keys) {
        const value = dynamicBindings[key];
        if (Array.isArray(value)) return value;
    }
    return [];
}

export function dynamicValueMatchesStep(value, identity) {
    if (!isNonEmpty(value)) return false;
    const valueKey = String(value);
    const keys = Array.isArray(identity?.candidateKeys) ? identity.candidateKeys : [];
    return keys.includes(valueKey);
}

/**
 * True when `step` is listed in `dynamicResult.dynamicStepIds`.
 *
 * Studio parity: ids are compared case-sensitively (see
 * `AutomationStudio/.../StepEditorView.jsx` ~line 180). Matches against
 * `step.stepId` and `step.id` only (no index fallback) — the Studio's
 * `showDynamicStepBadge` additionally considers `localStep` ids, so it's
 * intentionally kept inline there rather than routed through this helper.
 */
export function isDynamicStep(step, dynamicResult) {
    const list = dynamicResult?.dynamicStepIds;
    if (!Array.isArray(list) || list.length === 0) return false;
    const idSet = new Set(list.map((x) => String(x)));
    return [step?.stepId, step?.id]
        .filter((x) => x != null && String(x).trim() !== '')
        .some((id) => idSet.has(String(id)));
}
